export default __webpack_public_path__ + "static/media/BY.ef2ed5b6.svg";